<template>
  <div class="plan">
    <div
      v-show="showTitle"
      class="titolo navy--text text--lighten-2 font-hemi-head pb-4 d-flex align-center"
    >
      <div class="mr-2" >Pianificazione</div>
      <v-btn
        small
        depressed
        class="primary font-hemi-head"
        @click="swithToRose"
        ><v-icon small>arrow_forward</v-icon> Rose
      </v-btn>
    </div>


      <div v-if="!my_squadra" class="pa-10">
        Attenzione. Solo i partecipanti all'asta possono pianificare le
        strategia di acquisto
      </div>

      <div v-else>
        <asta-consiglio></asta-consiglio>
        <v-list :class="{ 'nice-scroll': !is_mobile }" class="recycle-scroller">
          <div v-for="(slots, ruolo_abc) in myPlan" :key="ruolo_abc">
            <asta-slot
              v-for="(slotData, slot, i) in slots"
              :key="ruolo_abc + '_' + slot"
              :ruolo_abc="ruolo_abc"
              :iSlot="slot"
              :i="i"
            ></asta-slot>
          </div>
        </v-list>
        <asta-plan-numpad></asta-plan-numpad>
        <dialog-associa-calciatore></dialog-associa-calciatore>
        <dialog-associa-slot></dialog-associa-slot>
        <dialog-plan-settings></dialog-plan-settings>
      </div>
    </div>
  </div>
</template>

<script>
import db from "../js/db";

import mixins from "../js/mixins";
import toast from "../js/toast";
import Constants from "../js/constants";
import AstaSlot from "./AstaSlot";
import AstaConsiglio from "./AstaConsiglio";
import AstaPlanNumpad from "./dialogs/AstaPlanNumpad";
import DialogAssociaCalciatore from "./dialogs/DialogAssociaCalciatore";
import DialogAssociaSlot from "./dialogs/DialogAssociaSlot";
import DialogPlanSettings from "./dialogs/DialogPlanSettings";
import Vuex from "vuex";

export default {
  name: "asta-plan",
  components: {
    AstaSlot,
    AstaPlanNumpad,
    DialogAssociaCalciatore,
    DialogAssociaSlot,
    DialogPlanSettings,
    AstaConsiglio,
  },
  mixins: [mixins, toast],
  data() {
    return {
      tipoConsiglio: "neutro",
      effectConsiglio: "",
      actionConsiglio: null,
      actionConsiglioText: "",
      numNoCrediti: 0,
      calciatoreDaAssociare: null,
    };
  },
  props: {
    showTitle: {
      type: Boolean,
    },
  },
  created() {},
  mounted() {
    console.log("--> AstaPlan mounted.");
    db.on("calciatoreAssegnato", this.handleAssegnazione);
  },
  destroyed() {
    console.log("<-- AstaPlan destroyed.");
    db.off("calciatoreAssegnato", this.handleAssegnazione);
  },
  methods: {
    promptDialogAssociaSlot() {
      if (this.calciatoreDaAssociare) {
        db.emit("DialogAssociaSlot", this.calciatoreDaAssociare);
      }
    },
    swithToRose() {
      this.$store.dispatch("switchPlanOrRose", "rose");
    },
    isPianificato(calciatore_id, ruolo_abc) {
      let output = null;
      for (const slot in this.myPlan[ruolo_abc]) {
        // solo se non è già uno slot associato
        if (this.myPlan[ruolo_abc][slot]["associato"] == "") {
          // sennò controlla se era pianificato in questo slot
          const calciatori = this.myPlan[ruolo_abc][slot]["calciatori"];
          if (calciatori.includes(calciatore_id)) {
            output = slot;
            return output;
          }
        }
      }
      return output;
    },
    getFreeSlot(ruolo_abc) {
      for (const slot in this.myPlan[ruolo_abc]) {
        // se non è già uno slot associato
        if (this.myPlan[ruolo_abc][slot]["associato"] == "") {
          return slot;
        }
      }
      return null;
    },
    handleAssegnazione(assegnazione) {
      const calciatore_id = assegnazione.calciatore_id;
      const squadra_id = assegnazione.squadra_id;
      if (squadra_id == this.my_squadra.id) {
        // se è già stato associato nella pianificazione, nn fare nulla
        // (potrebbe capitare quando aggiorno la pagina e l'ultimo log è un'assegnazione)
        if (!this.associati.includes(calciatore_id)) {
          const ruolo_id = this.calciatori[calciatore_id].ID_Ruolo;
          const ruolo_abc = _.invert(Constants.RUOLO)[ruolo_id];
          const slot = this.isPianificato(calciatore_id, ruolo_abc);
          if (slot) {
            // è tra i pianificati in uno slot non ancora associato
            db.setPlanAssociato(ruolo_abc, slot, calciatore_id);
          } else {
            // non è tra i pianificati
            if (this.associazioneMethod == Constants.PLAN_ASSOCIAZIONE.MANU) {
              this.calciatoreDaAssociare = calciatore_id;
              this.promptDialogAssociaSlot();
            } else if (
              this.associazioneMethod == Constants.PLAN_ASSOCIAZIONE.AUTO
            ) {
              const freeSlot = this.getFreeSlot(ruolo_abc);
              if (freeSlot) {
                db.setPlanAssociato(ruolo_abc, freeSlot, calciatore_id);
              } else {
                // PLAN_ASSOCIAZIONE.AUTO è il default
                // => quindi vale anche per chi non la fatto alcuna pianificazione
                // voglio far apparire il seguente alert solo a chi ha fatto una pianificazione:
                // mi affido a numNoCrediti
                // if (this.numNoCrediti == 0) {
                //   Swal.fire({
                //     icon: "warning",
                //     title: "Pianificazione",
                //     text: "Non ho trovato alcuno slot libero in cui inserire il calciatore appena acquistato. Probabilmente hai impostato un numero di calciatori troppo basso per questo ruolo. Aumentalo in Pianificazione -> Imposta",
                //     confirmButtonText: "Apri Impostazioni Pianificazione",
                //   }).then((result) => {
                //     if (result.isConfirmed == true) {
                //       this.promptDialogPlanSettings();
                //     }
                //   });
                // }
              }
            } else {
              // do nothing
            }
          }
        }
      }
    },
  },

  computed: {
    associazioneMethod() {
      return this.my_squadra?.settings.plan.associazione;
    },
    ...Vuex.mapGetters(["myPlan", "associati"]),
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.plan {
  height: 100%;
}
</style>
